var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChytrakrizovatkaKratka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120.44 26.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.22,
    y: 0.22,
    width: 119.99,
    height: 23.48,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.22,
    y: 0.22,
    width: 119.99,
    height: 23.48,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".45px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.22,
    y: 0.22,
    width: 119.99,
    height: 23.48,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.22,
    y: 22.39,
    width: 119.99,
    height: 4,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.22,
    y: 0.22,
    width: 8.26,
    height: 23.48,
    style: {
      fill: "#d1c4dd"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.22,
    y: 0.22,
    width: 119.99,
    height: 23.48,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "#615b67"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.22,
    y: 0.22,
    width: 8.26,
    height: 23.48,
    style: {
      fill: "#615b67"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.22,
    y: 0.22,
    width: 119.99,
    height: 23.48,
    rx: 1.78,
    ry: 1.78,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".45px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.22,
    y: 0.22,
    width: 8.26,
    height: 23.48,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 3.79,
    width: 6.71,
    height: 7.45,
    rx: 1,
    ry: 1,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.36 5.46 76.36 4.82 74.75 4.82 74.75 5.46 73.31 5.46 73.31 9.95 77.8 9.95 77.8 5.46 76.36 5.46",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.12,
    y1: 9.29,
    x2: 74.12,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.08,
    y1: 9.29,
    x2: 75.08,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.04,
    y1: 9.29,
    x2: 76.04,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 9.29,
    x2: 77,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.35,
    y: 3.79,
    width: 6.71,
    height: 7.45,
    rx: 1,
    ry: 1,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.51 5.46 84.51 4.82 82.9 4.82 82.9 5.46 81.46 5.46 81.46 9.95 85.95 9.95 85.95 5.46 84.51 5.46",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.27,
    y1: 9.29,
    x2: 82.27,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.23,
    y1: 9.29,
    x2: 83.23,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.19,
    y1: 9.29,
    x2: 84.19,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.15,
    y1: 9.29,
    x2: 85.15,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 3.79,
    width: 6.71,
    height: 7.45,
    rx: 1,
    ry: 1,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.67 5.46 92.67 4.82 91.06 4.82 91.06 5.46 89.62 5.46 89.62 9.95 94.11 9.95 94.11 5.46 92.67 5.46",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.42,
    y1: 9.29,
    x2: 90.42,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.38,
    y1: 9.29,
    x2: 91.38,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.34,
    y1: 9.29,
    x2: 92.34,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.3,
    y1: 9.29,
    x2: 93.3,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.66,
    y: 3.79,
    width: 6.71,
    height: 7.45,
    rx: 1,
    ry: 1,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.82 5.46 100.82 4.82 99.21 4.82 99.21 5.46 97.77 5.46 97.77 9.95 102.26 9.95 102.26 5.46 100.82 5.46",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.57,
    y1: 9.29,
    x2: 98.57,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.53,
    y1: 9.29,
    x2: 99.53,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.49,
    y1: 9.29,
    x2: 100.49,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.45,
    y1: 9.29,
    x2: 101.45,
    y2: 8.34,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 12.68,
    width: 6.71,
    height: 7.45,
    rx: 1,
    ry: 1,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.36 14.35 76.36 13.72 74.75 13.72 74.75 14.35 73.31 14.35 73.31 18.84 77.8 18.84 77.8 14.35 76.36 14.35",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.12,
    y1: 18.19,
    x2: 74.12,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.08,
    y1: 18.19,
    x2: 75.08,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.04,
    y1: 18.19,
    x2: 76.04,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 18.19,
    x2: 77,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.35,
    y: 12.68,
    width: 6.71,
    height: 7.45,
    rx: 1,
    ry: 1,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.51 14.35 84.51 13.72 82.9 13.72 82.9 14.35 81.46 14.35 81.46 18.84 85.95 18.84 85.95 14.35 84.51 14.35",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.27,
    y1: 18.19,
    x2: 82.27,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.23,
    y1: 18.19,
    x2: 83.23,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.19,
    y1: 18.19,
    x2: 84.19,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.15,
    y1: 18.19,
    x2: 85.15,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 12.68,
    width: 6.71,
    height: 7.45,
    rx: 1,
    ry: 1,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.67 14.35 92.67 13.72 91.06 13.72 91.06 14.35 89.62 14.35 89.62 18.84 94.11 18.84 94.11 14.35 92.67 14.35",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.42,
    y1: 18.19,
    x2: 90.42,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.38,
    y1: 18.19,
    x2: 91.38,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.34,
    y1: 18.19,
    x2: 92.34,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.3,
    y1: 18.19,
    x2: 93.3,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.66,
    y: 12.68,
    width: 6.71,
    height: 7.45,
    rx: 1,
    ry: 1,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.82 14.35 100.82 13.72 99.21 13.72 99.21 14.35 97.77 14.35 97.77 18.84 102.26 18.84 102.26 14.35 100.82 14.35",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.57,
    y1: 18.19,
    x2: 98.57,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.53,
    y1: 18.19,
    x2: 99.53,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.49,
    y1: 18.19,
    x2: 100.49,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.45,
    y1: 18.19,
    x2: 101.45,
    y2: 17.24,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.74,
    y: 8.55,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.74,
    y: 3.79,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.46,
    y: 15.3,
    width: 1.97,
    height: 1.97,
    rx: 0.99,
    ry: 0.99,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 3.79,
    width: 1.97,
    height: 1.97,
    rx: 0.99,
    ry: 0.99,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.76,
    y: 3.79,
    width: 51.75,
    height: 16.35,
    rx: 1,
    ry: 1,
    style: {
      fill: "#d1c4dd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.03,
    y: 6.16,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.07,
    y: 10.71,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.79,
    y: 10.71,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#77acdd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.66,
    y: 10.71,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.76,
    y: 6.16,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.45,
    y: 6.16,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.17,
    y: 6.16,
    width: 9.2,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.72,
    y: 6.16,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.74,
    y: 6.16,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.03,
    y: 10.71,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.05,
    y: 10.71,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#77acdd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.76,
    y: 10.71,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.77,
    y: 10.71,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.48,
    y: 10.71,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 10.71,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.36,
    y: 10.71,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.14,
    y: 6.16,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.16,
    y: 6.16,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#77acdd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.4,
    y: 15.3,
    width: 1.97,
    height: 1.97,
    rx: 0.99,
    ry: 0.99,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.8,
    y: 15.3,
    width: 1.97,
    height: 1.97,
    rx: 0.99,
    ry: 0.99,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.58,
    y1: 0.22,
    x2: 68.58,
    y2: 23.7,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.99,
    y1: 0.22,
    x2: 106.99,
    y2: 23.7,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChytrakrizovatkaKratka);
export default __webpack_public_path__ + "static/media/chytrakrizovatka_kratka.e10ee1196bb2decab27e9a35b78f82f2.svg";
export { ForwardRef as ReactComponent };